<template>
    <SocialAuthBtn
        img="https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%22G%22_Logo.svg/240px-Google_%22G%22_Logo.svg.png"
        :label="$t('shared.loginModule.socialAuthBtns.continueWithGoogle')"
        color="white"
        class="google-btn"
        @click="gLogin"
        :tiny="tiny"
    />
</template>

<script>
import SocialAuthBtn from './SocialAuthBtn';
import GoogleFlow from '~/utils/socialAuth/GoogleFlow';

export default {
    name: 'GoogleLoginBtn',
    components: { SocialAuthBtn },
    props: {
        redirectPath: String,
        tiny: Boolean,
    },
    methods: {
        async gLogin() {
            let queryObject = {
                redirectUrl:
                    this.$interfaces.logInModule.getRedirect() ||
                    this.$route.path,
            };

            GoogleFlow.startAuthFlow(this.redirectPath, queryObject);
        },
    },
};
</script>

<style>
.google-btn {
    color: black !important;
    border: thin solid #ddd !important;
}

.google-btn > img {
    margin-right: 38px !important;
    width: 25px !important;
    height: 25px !important;
}
</style>
